import { Injectable } from '@angular/core';
 
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class MailService {
 
  baseURL: string = "https://api-althea-health-gateway-demo.azurewebsites.net/Smtp/send"; //"https://localhost:57043/Smtp/send";
  mailTo: AddressData = new AddressData ();
  mailFrom: AddressData = new AddressData ();

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'RowKey': '888888', 'AccountKey': 'jsdlfjslkdjf=sdflskdfljsdf34kjsdf.2342'})
  };

  constructor(private http: HttpClient) {
    this.mailTo.address = "sales@altheasoft.com";
    this.mailTo.name = "Support";

    this.mailFrom.address = "sales@altheasoft.com";
    this.mailTo.name = "Support";
  }
 
  send(msg: MessageData): Observable<any> {
    msg.to = this.mailTo;
    msg.from = this.mailFrom;
    
    let json = JSON.stringify(msg);
    return this.http.post(this.baseURL, json, this.httpOptions)
  }
 
}

export class MessageData {
    from: AddressData;
    to: AddressData;
    toBulk: AddressData[];
    subject: any;
    textData: any;
  } 

  export class AddressData {
    address: any;
    name: any;
  }